import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { EServices } from "@/types";
import { IVForm } from "@/types";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";

import { requiredLengthRule, requiredRule } from "@/utils/rules";
import { nigerianBankAccountRule } from "@/utils/rules";
import IIndexable from "@/utils/types/IIndexable";
import { Mixins, Component, Ref, Watch, Inject } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { IBank, IBankAccount, IBanksClient } from "../../types";
import VPasswordField from "@/vuetify-extensions/VPasswordField.vue";

const BankModule = namespace("BankModule");

export interface IBankAccountEditor {
  create(): void;
  edit(bankAccount: IBankAccount): void;
}

@Component({
  components: {
    VPasswordField,
  },
})
export default class BankAccountEditor
  extends Mixins(JackocoinsNetworkManagerMixin)
  implements IBankAccountEditor
{
  show = false;
  accountName = "";
  accountNumber = "";
  bank: IBank | null = null;
  accountType: "savings" | "current" | null = null;
  password = "";
  selectedBankAccountId: number | null = null;
  bankImages: IIndexable = {};

  @Ref()
  bankAccountEditorForm!: IVForm;

  @BankModule.State
  banks!: IBank[];

  @Inject(EServices.banks)
  banksClient!: IBanksClient;

  get title(): string {
    return !this.selectedBankAccountId
      ? "Add Bank Account"
      : "Update Bank Account";
  }

  get action(): string {
    return !this.selectedBankAccountId ? "Add" : "Update";
  }

  requiredLengthRule = requiredLengthRule;
  requiredRule = requiredRule;
  nigerianBankAccountRule = nigerianBankAccountRule;

  getBank(bankIndex: string): IBank {
    return this.banks.find(
      (bank) => bankIndex.toString() == bank.id.toString()
    )!;
  }

  @Watch("banks")
  getBankImages() {
    for (const bank of this.banks) {
      try {
        this.bankImages[
          bank.name
        ] = require(`@/assets/images/${bank.name}.png`);
      } catch (e) {
        continue;
      }
    }
  }

  create(): void {
    this.show = true;
  }

  edit(bankAccount: IBankAccount): void {
    this.accountName = bankAccount.accountName;
    this.accountNumber = bankAccount.accountNumber;
    this.bank = this.getBank(bankAccount.bank.id.toString());
    this.accountType = bankAccount.accountType;
    this.selectedBankAccountId = bankAccount.id;
    this.show = true;
  }

  close() {
    this.show = false;
    this.bankAccountEditorForm.reset();
    this.selectedBankAccountId = null;
  }

  @throwsNetworkError()
  async save() {
    if (!this.bankAccountEditorForm.validate()) return;
    if (this.selectedBankAccountId) {
      await this.banksClient.updateBank(
        this.selectedBankAccountId,
        this.accountName,
        this.accountNumber,
        this.bank!.id,
        this.accountType!,
        this.password
      );
      toast({
        message: "Bank account updated",
        iconColor: "green",
        icon: "mdi-check",
      });
    } else {
      await this.banksClient.addBank(
        this.accountName,
        this.accountNumber,
        this.bank!.id,
        this.accountType!
      );
      toast({
        message: "New bank account added",
        iconColor: "green",
        icon: "mdi-check",
      });
    }
    this.$emit("saved");
    this.close();
  }

  @Watch("error.save")
  onError(message: string) {
    if (message)
      toast({ icon: "mdi-exclamation-thick", iconColor: "red", message });
  }
}
